import PropTypes from "prop-types";
// @mui
import { Box } from "@mui/material";
// hooks
import useResponsive from "../../hooks/useResponsive";
// config
import { HEADER, NAV } from "../../config";
// components
import { useSettingsContext } from "../../components/settings";

// ----------------------------------------------------------------------

export const SPACING = 8;

Main.propTypes = {
    sx: PropTypes.object,
    children: PropTypes.node
};

export default function Main({ children, sx, ...other }) {

    return (
        <Box
            component="main"
            sx={{
                flexGrow: 1,
            }}
            {...other}>
            {children}
        </Box>
    );
}
